/*!
 * Copyright Optimus Ride 2019
 */

import { WaypointDescription as GrpcWaypoint } from '../../grpc/common_pb';
import { toCoordinates, Coordinates } from './common';
import { StationType as GrpcTripStatus } from '../../grpc/route_plan_pb';

export enum TripStatus {
    NONE,
    PICKUP,
    DROPOFF,
}

export interface WaypointDescription {
    name: string;
    waypointId: string;
    coordinates: Coordinates;
    isStation: boolean;
}

export interface AnnotatedWaypointDescription extends WaypointDescription {
    tripStatus: TripStatus;
    isSent: boolean;
}

export function toWaypointDescription(waypoint: GrpcWaypoint): WaypointDescription {
    const waypointId = waypoint.getWaypointid();

    return {
        name: waypoint.getName(),
        waypointId: waypointId ? waypointId.getId() : '',
        coordinates: toCoordinates(waypoint.getCoordinate()),
        isStation: isStation(waypoint.getType()),
    };
}

export function toAnnotatedWaypointDescription(waypoint: WaypointDescription): AnnotatedWaypointDescription {
    return {
        ...waypoint,
        tripStatus: TripStatus.NONE,
        isSent: false,
    };
}

function isStation(waypointType: GrpcWaypoint.WaypointType): boolean {
    return waypointType === GrpcWaypoint.WaypointType.STATION;
}

export function findQueueBreakpointIndex(waypoints: AnnotatedWaypointDescription[]) {
    return waypoints.findIndex(w => w.isSent === false && w.tripStatus !== TripStatus.NONE);
}

export function fromTripStatus(tripStatus: TripStatus): GrpcTripStatus {
    switch(tripStatus) {
        case TripStatus.PICKUP:
            return GrpcTripStatus.PICKUP;
        case TripStatus.DROPOFF:
            return GrpcTripStatus.DROPOFF;
        case TripStatus.NONE:
            return GrpcTripStatus.NONE;
        default:
            throw new Error('Unknown Autonomy Status enum value');
    }
}
